import { Context, useContext } from 'react';

export function useEnsureContext<T>(context: Context<T | undefined>): T {
  const ctx = useContext(context);
  if (!ctx) {
    throw new Error(`Required ${context} doesn't exist`);
  }
  return ctx;
}
